import React, { useState, useEffect } from "react";
import { Box, Typography, Tabs, Tab, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Building2Icon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import BadgeIcon from "@mui/icons-material/Badge";
import CodeIcon from "@mui/icons-material/Code";
import SchoolIcon from "@mui/icons-material/School";
import BackBtn from "../../widgets/BackBtn";

import Exhibitors from "../exhibitors/Exhibitors";
import Visitors from "../../components/visitors/Visitors";
import ManageDelegates from "../../components/visitors/ManageDelegates";
import ServiceCodesList from "../exhibitors/ServiceCodesList";
import { USER_ROLES } from "../../utils/constants";

const TAB_ROUTES = [
  { path: "/exhibitors-list", label: "Exhibitor List", icon: <Building2Icon /> },
  { path: "/visitors-list", label: "Visitors List", icon: <PeopleIcon /> },
  { path: "/manage-delegates", label: "Trade Delegates", icon: <BadgeIcon /> },
  { path: "/students-list", label: "Students List", icon: <SchoolIcon /> },
  { path: "/service-codes-list", label: "Service Codes", icon: <CodeIcon /> },
];

const UsersListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getInitialTab = () => {
    const currentPath = location.pathname;
    const index = TAB_ROUTES.findIndex((tab) => tab.path === currentPath);
    return index !== -1 ? index : 0;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);

  useEffect(() => {
    const index = TAB_ROUTES.findIndex((tab) => tab.path === location.pathname);
    if (index !== -1) {
      setActiveTab(index);
    }
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    navigate(TAB_ROUTES[newValue].path);
  };

  return (
    <Box sx={{ pb: 6 }}>
      <BackBtn />

      {/* Page Header */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 800, color: "#0F172A", letterSpacing: "-0.02em" }}
        >
          Users & Directory Center
        </Typography>
        <Typography variant="body2" sx={{ color: "#64748B", mt: 0.5 }}>
          Manage event exhibitors, visitors, trade delegates, students, and service codes.
        </Typography>
      </Box>

      {/* Tabs Header */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          bgcolor: "#FFFFFF",
          mb: 3,
          px: 1,
          pt: 1,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: "48px",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.9rem",
              minHeight: "48px",
              borderRadius: "8px 8px 0 0",
              px: 2.5,
              color: "#64748B",
              "&.Mui-selected": {
                color: "#2563EB",
                fontWeight: 700,
              },
            },
            "& .MuiTabs-indicator": {
              height: "3px",
              borderRadius: "3px 3px 0 0",
              backgroundColor: "#2563EB",
            },
          }}
        >
          {TAB_ROUTES.map((tab, idx) => (
            <Tab
              key={idx}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {tab.icon}
                  <span>{tab.label}</span>
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>

      {/* Tab Panels */}
      <Box>
        {activeTab === 0 && <Exhibitors />}
        {activeTab === 1 && <Visitors type={USER_ROLES.VISITOR} />}
        {activeTab === 2 && <ManageDelegates />}
        {activeTab === 3 && <Visitors type={USER_ROLES.STUDENT} />}
        {activeTab === 4 && <ServiceCodesList />}
      </Box>
    </Box>
  );
};

export default UsersListPage;
